import { Injectable } from "@angular/core";
import { MCAuthoritiesEventsAgriculture } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsAgriculture extends MCAuthoritiesEventsAgriculture {

}
